import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import { RequiredThemeKeys, themed } from "@smartsheet/sds-theme-internal";
import { LabelHTMLAttributes, ReactNode } from "react";
import { sizes } from "../../../constants/spacing";
import { TypeRampV2 } from "../../typography";
import { FormLabelValidationState } from "../types";

export const labelVariantProps = themed({
    "lodestar-light": "bodyStrong",
    "ursa-light": "Inter--12px--600w",
});

export const labelStyles = themed({
    color: {
        rest: {
            "lodestar-light": color("color--text--neutral--default"),
            "ursa-light": color("color--text--neutral--strong"),
        },
        error: {
            "lodestar-light": color("color--text--error--weak"),
            "ursa-light": color("color--text--neutral--strong"),
        },
    },
    margin: {
        "lodestar-light": sizes.xSmall,
        "ursa-light": sizes.xxSmall,
    },
});

interface FormLabelLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    children: ReactNode;
    themeMode: RequiredThemeKeys;
    validationState: FormLabelValidationState | undefined;
}

export const FormLabelLabel = styled(TypeRampV2)<FormLabelLabelProps>`
    display: flex;
    margin-bottom: ${({ themeMode }) => labelStyles.margin(themeMode)}px;
    color: ${({ themeMode, validationState }) =>
        validationState === "error" ? labelStyles.color.error(themeMode) : labelStyles.color.rest(themeMode)};
`;
